// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__qEV38","topBottomGutter":"Layout_topBottomGutter__2RcAp"};